import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AccessControl from '../../AccessControl';
import { PERMISSIONS_KEY, ROUTES } from '../../common/constants';
import MediaLibrary from './pages/MediaLibrary';

const MediaLibraryWrapper = () => (
  <Switch>
    <Route
      exact
      path={ROUTES?.MEDIA_LIBRARY}
      render={(props) => (
        <AccessControl
          permissionKey={PERMISSIONS_KEY?.MASTER_LIST_MEDIA_UPLOAD}
        >
          <MediaLibrary {...props} />
        </AccessControl>
      )}
    />
  </Switch>
);

export default MediaLibraryWrapper;
